const validateActions = async () => {
  return {
    data: {
      actions_valid: true,
      schedule_valid: true,
      actions_error: null,
      validation_disabled: true,
    },
  };
};

export default validateActions;
